module.exports = __webpack_public_path__ + "img/map-active.0586782c.png";